import applServices from "public/home/applServices.svg";
import csp from "public/home/csp.svg";
import isp from "public/home/isp.svg";
import mssp from "public/home/mssp.svg";
import iaasImg from "public/home/iaas.svg";
import { ContentCard } from "@/components/contentCard";
import { MAIN_ROUTES } from "@/constants/routes";

export const NAVIGATION_CARDS_CONSTANTS = {
  title: "Our Expertise | Your Success",
  desc: "Full-Service MSP & CSP Specializing in Cloud, Security, IoT & Datacenter Technologies.",
  list: [
    {
      image: iaasImg,
      title: "Infrastructure as a service ",
      content: (
        <ContentCard
          link={MAIN_ROUTES.IAAS}
          points={[
            "Bare-Metal Server",
            "Dedicated servers ",
            "GPU Hosting",
            "Virtual Desktop Infrastructure",
            "Block storage | S3 Storage",
            "Disaster Recovery",
          ]}
        />
      ),
    },
    {
      image: csp,
      title: "Private Cloud",
      content: (
        <ContentCard
          link={{ pathname: MAIN_ROUTES.CLOUD_SERVICES, query: { tab: "0" } }}
          points={[
            "OneMind's Managed Open Stack(MOST)",
            "Zadara Cloud",
            "VMware Cloud",
            "OEM Converged Architecture",
            "Private K8 clusters",
            "Virtuozzo IAAS and PAAS",
            "Encrypted Storage Clusters",
            "Managed, Unmanaged, Co-managed",
          ]}
        />
      ),
    },
    {
      image: isp,
      title: "POC Cloud",
      content: (
        <ContentCard
          link={{ pathname: MAIN_ROUTES.CLOUD_SERVICES, query: { tab: "1" } }}
          points={[
            "Lab-as-a-service",
            "POC-as a service",
            "Network Digital Twins",
            "Certification Labs",
            "Physical Labs (SI | VAR|COE)",
            "Network Automation",
            "Performance Labs | OEM Test Labs",
            "Emulate | Simulate | Real",
          ]}
        />
      ),
    },
    {
      image: mssp,
      title: "Network Services",
      content: (
        <ContentCard
          link={MAIN_ROUTES.NETWORK_SERVICES}
          points={[
            "VMware Migration",
            "Migration to Zadara",
            "SDN | SD-WAN | Wired | Wireless",
            "Wired and Wireless Networks",
            "Design and Deployment",
            "Network Observability and NMS",
            "Colocation",
            "NOC | SOC | Helpdesk",
          ]}
        />
      ),
    },
    {
      image: applServices,
      title: "Application Services",
      content: (
        <ContentCard
          link={MAIN_ROUTES.APPLICATION_SERVICES}
          points={[
            "Hosted Open-Text NOM",
            "Hosted Elastic",
            "Hosted Grafana",
            "Hosted PBX",
            "Hosted CMS",
            "Hosted Netbox",
            "Hosted Rancher ",
            "Inuvika VDI platform ",
          ]}
        />
      ),
    },
  ],
};
